export class MenuScreenEntity {
  id?: string
  key?: string | null
  name?: string | null
  sortOrder?: number
  section?: string | null
  isActive?: boolean
}
